import { Button, ButtonGroup } from "react-bootstrap";
import '../styles/ToggleButton.css'


const ToggleButton = ({ isOn, handleToggle, onText, offText, variant = 'primary' }) => {

    return (
        <ButtonGroup>
            <Button variant={isOn ? `outline-${variant}` : variant} onClick={handleToggle} disabled={!isOn}>{offText}</Button>
            <Button variant={isOn ? variant : `outline-${variant}`} onClick={handleToggle} disabled={isOn}>{onText}</Button>
        </ButtonGroup>
    );
};


export default ToggleButton;